export default __webpack_public_path__ + "static/media/CFD222.c549b2db.jpg";